import { api } from '../../../lib/api'

export const RESET_REGISTRATION_STEP = 'RESET_REGISTRATION_STEP'
export const REGISTER_FLOW_USER_REQUEST = 'REGISTER_FLOW_USER_REQUEST'
export const REGISTER_FLOW_USER_SUCCESS = 'REGISTER_FLOW_USER_SUCCESS'
export const REGISTER_FLOW_USER_FAILED = 'REGISTER_FLOW_USER_FAILED'

export const REGISTER_FLOW_CONTACT_REQUEST = 'REGISTER_FLOW_CONTACT_REQUEST'
export const REGISTER_FLOW_CONTACT_SUCCESS = 'REGISTER_FLOW_CONTACT_SUCCESS'
export const REGISTER_FLOW_CONTACT_FAILED = 'REGISTER_FLOW_CONTACT_FAILED'

export const REGISTER_FLOW_SUBSCRIPTIONS_REQUEST = 'REGISTER_FLOW_SUBSCRIPTIONS_REQUEST'
export const REGISTER_FLOW_SUBSCRIPTIONS_SUCCESS = 'REGISTER_FLOW_SUBSCRIPTIONS_SUCCESS'
export const REGISTER_FLOW_SUBSCRIPTIONS_FAILED = 'REGISTER_FLOW_SUBSCRIPTIONS_FAILED'

export const REGISTER_FLOW_PAYMENT_INFO_REQUEST = 'REGISTER_FLOW_PAYMENT_INFO_REQUEST'
export const REGISTER_FLOW_PAYMENT_INFO_SUCCESS = 'REGISTER_FLOW_PAYMENT_INFO_SUCCESS'
export const REGISTER_FLOW_PAYMENT_INFO_FAILED = 'REGISTER_FLOW_PAYMENT_INFO_FAILED'

export const REGISTER_FLOW_FINAL_REQUEST = 'REGISTER_FLOW_FINAL_REQUEST'
export const REGISTER_FLOW_FINAL_SUCCESS = 'REGISTER_FLOW_FINAL_SUCCESS'
export const REGISTER_FLOW_FINAL_FAILED = 'REGISTER_FLOW_FINAL_FAILED'


export const resetRegistrationStep = (step) => {
    return { type: RESET_REGISTRATION_STEP, step }
}

export const registerFlowStep1 = function (username, email, password, passwordRepeat, humanVerificationCode, moduleOptions, onComplete) {
    return function dispatch(dispatch) {
        dispatch({ type: REGISTER_FLOW_USER_REQUEST })
        api.registerStep1(username, email, password, passwordRepeat, humanVerificationCode, moduleOptions.filter(o => o.active)).then(response => {
            if (onComplete) onComplete()
            if (response.error) {
                dispatch({
                    type: REGISTER_FLOW_USER_FAILED,
                    payload: { email, password, passwordRepeat, username, moduleOptions },
                    error: { validation: response.error }
                })
            } else {
                dispatch({
                    type: REGISTER_FLOW_USER_SUCCESS,
                    payload: {
                        username,
                        email,
                        password,
                        passwordRepeat,
                        moduleOptions,
                    }
                    , error: null
                })
            }
        }).catch(error => {
            dispatch({
                payload: { email, password, passwordRepeat, username, moduleOptions },
                type: REGISTER_FLOW_USER_FAILED,
                error
            })
        })
    }
}

export const registerFlowStep2 = function (phone, profilePicture, onComplete) {
    return function (dispatch) {
        dispatch({
            type: REGISTER_FLOW_CONTACT_REQUEST
        })
        api.registerStep2(phone, profilePicture).then(response => {
            if (onComplete) onComplete()
            if (response.error) {
                dispatch({
                    type: REGISTER_FLOW_CONTACT_FAILED,
                    payload: { phone, profilePicture },
                    error: { validation: response.error }
                })
            } else {
                dispatch({
                    type: REGISTER_FLOW_CONTACT_SUCCESS,
                    payload: { phone, profilePicture },
                    error: null
                })
            }
        }).catch(error => {
            dispatch({
                type: REGISTER_FLOW_CONTACT_FAILED,
                payload: { phone, profilePicture },
                error
            })
        })
    }
}

export const registerFlowStep3 = (subscriptions, onComplete) => {
    return function (dispatch) {
        dispatch({
            type: REGISTER_FLOW_SUBSCRIPTIONS_REQUEST
        })
        api.registerStep3(subscriptions.filter(s => s.subscriptionId).map(s => ({ subscriptionId: s.subscriptionId, domainId: s.domainId }))).then(response => {
            if (onComplete) onComplete()
            if (response.error) {
                dispatch({
                    type: REGISTER_FLOW_SUBSCRIPTIONS_FAILED,
                    payload: { subscriptions },
                    error: { validation: response.error }
                })
            } else {
                dispatch({
                    type: REGISTER_FLOW_SUBSCRIPTIONS_SUCCESS,
                    payload: { subscriptions },
                    error: null
                })
            }
        }).catch(error => {
            dispatch({
                type: REGISTER_FLOW_SUBSCRIPTIONS_FAILED,
                payload: { subscriptions },
                error
            })
        })
    }
}

export const registerFlowStep4 = function (step1, step2, step3, step4, onComplete) {

    return function (dispatch) {
        dispatch({type: REGISTER_FLOW_FINAL_REQUEST})
        api.registerStep4(step1, step2, step3, step4).then(response => {
            if (onComplete) onComplete()
            if (response.error) {
                dispatch({
                    type: REGISTER_FLOW_FINAL_FAILED,
                    payload: { step4 },
                    error: { validation: response.error }
                })
            } else {
                dispatch({
                    type: REGISTER_FLOW_FINAL_SUCCESS,
                    payload: { step4 }
                })
            }
        }).catch(error => {
            dispatch({
                type: REGISTER_FLOW_FINAL_FAILED,
                error,
                payload: { step4 }
            })
        })
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/register-flow/register-flow.js